module.exports = {
	"name": "spectra-data",
	"version": "3.0.1",
	"description": "spectra-data project - manipulate spectra",
	"keywords": [
		"spectra-data",
		"project"
	],
	"author": "Andres Castillo",
	"contributors": [
		"Michaël Zasso",
		"Luc Patiny"
	],
	"repository": "cheminfo-js/spectra-data",
	"bugs": {
		"url": "https://github.com/cheminfo-js/spectra-data/issues"
	},
	"homepage": "https://github.com/cheminfo-js/spectra-data",
	"license": "MIT",
	"main": "./src/index.js",
	"scripts": {
		"eslint": "eslint src test --cache",
		"eslint-fix": "npm run eslint -- --fix",
		"test": "npm run test-mocha",
		"test-mocha": "mocha --compilers js:babel-register --require should --reporter mocha-better-spec-reporter --recursive src/**/__tests__/**/*.js",
		"test-cov": "istanbul cover _mocha -- --compilers js:babel-register --require should --reporter dot --recursive src/**/__tests__/**/*.js",
		"test-travis": "istanbul cover _mocha --report lcovonly -- --compilers js:babel-register --require should --reporter mocha-better-spec-reporter --recursive src/**/__tests__/**/*.js && npm run eslint",
		"build": "cheminfo build"
	},
	"devDependencies": {
		"babel-cli": "^6.2.0",
		"babel-core": "^6.2.1",
		"babel-plugin-transform-es2015-block-scoping": "^6.1.18",
		"babel-preset-es2015-node4": "^2.0.1",
		"babel-register": "^6.2.0",
		"babelify": "^7.2.0",
		"babili": "0.0.8",
		"cheminfo-tools": "^1.13.0",
		"eslint": "^3.9.1",
		"eslint-config-cheminfo": "^1.5.2",
		"eslint-plugin-no-only-tests": "^1.1.0",
		"mocha": "^3.1.2",
		"mocha-better-spec-reporter": "^3.0.1",
		"should": "^11.1.1"
	},
	"dependencies": {
		"brukerconverter": "^1.0.1",
		"extend": "^3.0.0",
		"jcampconverter": "^2.4.5",
		"ml-array-utils": "^0.3.0",
		"ml-curve-fitting": "0.0.7",
		"ml-fft": "^1.3.5",
		"ml-gsd": "^2.0.1",
		"ml-matrix": "^2.1.0",
		"ml-matrix-peaks-finder": "^0.2.1",
		"ml-simple-clustering": "0.1.0",
		"ml-stat": "^1.3.0",
		"nmr-auto-assignment": "0.1.3",
		"nmr-predictor": "0.2.0",
		"nmr-range": "^0.1.10",
		"nmr-simulation": "0.2.0"
	}
};


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 95
// module chunks = 0